<script setup lang="ts">
import { computed } from 'vue';
import { renderAnnouncementMarkdown } from '@/utils/announcementMarkdown';

const props = defineProps<{ content: string }>();
const html = computed(() => renderAnnouncementMarkdown(props.content));
</script>

<template>
  <div class="announcement-markdown prose prose-slate max-w-none text-sm leading-7" v-html="html" />
</template>
